<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ReviewRejectModal',
})
</script>
<template>
  <Modal v-model:visible="visible" centered destroy-on-close title="驳回" width="600px" :confirm-loading="submitLoading" @ok="submit">
    <div class="ant-modal-bd">
      <Form ref="formRef" layout="vertical" label-align="left" :model="model" scroll-to-first-error class="ant-edit-form">
        <FormItem label="审核意见" name="shenHeYiJian" :rules="getRequiredRule('审核意见')">
          <Input.TextArea v-model:value="model.shenHeYiJian" placeholder="请输入" allowClear :autoSize="{ minRows: 4, maxRows: 8 }" />
        </FormItem>
        <FormItem label="监审组提供的整改清单" v-if="fileVisible">
          <FileUpload v-model:value="model.files!.jianShenQingDanFiles" :filesCol="{ span: 24 }" />
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script lang="ts" setup name="ReviewRejectModal">
import { Modal, Form, Input, message } from 'ant-design-vue'
import { ref } from 'vue'
import { FormItem } from '-/Common/Form'
import { FileUpload } from '-/Common/FileUpload'
import { getRequiredRule } from '@/constant/form'
import { handleFormError } from '@/hooks/useForm'
import { API_REVIEW_ADD } from '@/api/review'
const props = withDefaults(
  defineProps<{
    fileVisible?: boolean
  }>(),
  {
    fileVisible: true
  }
)
const emits = defineEmits<{
  (e: 'refresh'): void
}>()
const visible = ref(false)
const formRef = ref()
const submitLoading = ref(false)

const model = ref<Partial<ApiReview.Item>>({})

const close = () => {
  visible.value = false
  formRef.value?.resetFields?.()
  emits('refresh')
}

const sourceId = ref<string>()
const isAgree = ref<number>()
const sourceType = ref<number>()

const open = (_sourceId: string, _isAgree = 0, _sourceType = 0) => {
  visible.value = true
  sourceId.value = _sourceId
  isAgree.value = _isAgree
  sourceType.value = _sourceType
  model.value = {
    shenHeYiJian: '不同意，请修改后重新提交'
  }
  if (props.fileVisible) {
    model.value.files = {
      jianShenQingDanFiles: []
    }
  }
}
defineExpose({
  open
})

const submit = async () => {
  if (submitLoading.value) return

  submitLoading.value = true
  try {
    await formRef.value?.validate?.()
    const params: any = {
      ...model.value,
      sourceId: sourceId.value,
      isAgree: isAgree.value,
      sourceType: sourceType.value
    }
    await API_REVIEW_ADD(params)
    message.success('操作成功')
    close()
  } catch (err) {
    handleFormError(err)
  } finally {
    submitLoading.value = false
  }
}
</script>
